<div class="container black-link">
  <div class="row">
    <div class="col-md-12 col-lg-12 col-sm-12 text-center mb-4">
      <img
        src="/assets/images/waitlisted.png"
        alt="You are on the waitlist!"
        style="max-width: 80%"
        class="mb-4"
        />
      <h5>Due to high demand your application has been waitlisted.</h5>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-lg-8 offset-lg-2 col-sm-12 text-center">
      <p>
        Unfortunately the market you are in is at full capacity but we
        are growing fast! We will email you to confirm your shipment
        once you have been moved off the waitlist.
      </p>
      <br /><br />
      <p>
        The email address we have for you is:
        <span class="bold-text">{{ email }}</span
          >.
          <br />
          Not your best email? Reach out to us for help at
          <a href="mailto:contact&#64;playoctopus.com"
            >contact&#64;playoctopus.com</a
            >!
          </p>
          <br /><br />
          <p class="text-start mb-3">
            Please check out more about the Octopus Experience:
          </p>
          <ul class="text-start">
            <li>
              Read
              <a
                href="https://playoctopus.com/driver-reviews/"
                target="_blank"
                >what drivers are saying about us</a
                >
              </li>
              <li>
                Check out our
                <a
                  href="https://www.youtube.com/channel/UC7TxkO-8BObBDnAckFPejMA"
                  target="_blank"
                  >YouTube channel</a
                  >
                </li>
                <li>
                  Find frequently asked questions at
                  <a href="https://playoctopus.com/help" target="_blank"
                    >playoctopus.com/help</a
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="row contact-footer mt-4">
              <div class="col-sm-12 col-lg-8 offset-lg-2 text-center mt-4">
                <p class="lite-text">
                  If you have any questions or concerns, you may reach Octopus by
                  visiting
                  <a href="https://playoctopus.com/help" target="_blank"
                    >playoctopus.com/help
                  </a>
                  or by calling (240) 366-5877 (Monday - Friday).
                </p>
              </div>
            </div>
            <br />
            @if (referredBy === 'RYDARAPP') {
              <img
                src="https://promotions.api.rydar.io/ping-pong/playoctopus/jan_2019_app.png"
                />
            }
            @if (referredBy === 'RYDAREMAIL') {
              <img
                src="https://promotions.api.rydar.io/ping-pong/playoctopus/jan_2019_email.png"
                />
            }
            <br />
          </div>
